import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next'
import CameraCntx from "../contexts/CameraCntx";

const AgevolazioniFiscali = () => {
    const { t, i18n } = useTranslation();
    const { testoFooter, testoFooterEn } = useContext(CameraCntx);

    const getFooterTextByLingua = () => {
        if (i18n.language === 'it') {
            return testoFooter;
        } else if (i18n.language === 'en') {
            return testoFooterEn;
        }
    };

    return (
        <div className="container mt-3">
            <p dangerouslySetInnerHTML={{ __html: getFooterTextByLingua() }} />
        </div>
    )
}

export default AgevolazioniFiscali;
